// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { AddressOptionalRequest } from './address-optional-request';

// @ts-ignore
import { AdminLocationPhoneRequest } from './admin-location-phone-request';

// @ts-ignore
import { AdminPracticeLocationDetailsRequest } from './admin-practice-location-details-request';

/** See com.rev360.pms.api.controller.admin.general.location.AdminCreatePracticeLocationDetailsRequest */
/* istanbul ignore next */
@GandalfModel
export class AdminCreatePracticeLocationDetailsRequest extends AdminPracticeLocationDetailsRequest {

	@GandalfProperty({ designType: AddressOptionalRequest })
	address!: AddressOptionalRequest | null;

	@GandalfLabel('Barcode Label Location #')
	@GandalfValidator({ sizeString: { message: 'Barcode Label Location # cannot be longer than 2 characters', minLength: 0, maxLength: 2 } })
	@GandalfProperty({ designType: String })
	barcodeIdentifier!: string | null;

	@GandalfLabel('Claims Billing Location')
	@GandalfProperty({ designType: Number })
	billingLocationClaimsId!: number | null;

	@GandalfLabel('Statements Billing Location')
	@GandalfProperty({ designType: Number })
	billingLocationStatementsId!: number | null;

	@GandalfLabel('Billing Provider Name')
	@GandalfValidator({ sizeString: { message: 'Billing Provider Name cannot be longer than 100 characters', minLength: 0, maxLength: 100 } })
	@GandalfProperty({ designType: String })
	billingProviderName!: string | null;

	@GandalfConstantDecorator(constants.ClaimNpiEntity)
	@GandalfLabel('Claim NPI Entity')
	@GandalfProperty({ designType: constants.ClaimNpiEntity })
	claimNpiEntity!: constants.ClaimNpiEntity | null;

	@GandalfLabel('Co-Insurance Tax')
	@GandalfProperty({ designType: Number })
	coInsuranceTaxId!: number | null;

	@GandalfLabel('Co-Pay Tax')
	@GandalfProperty({ designType: Number })
	coPayTaxId!: number | null;

	@GandalfLabel('Deductible Tax')
	@GandalfProperty({ designType: Number })
	deductibleTaxId!: number | null;

	@GandalfLabel('Default Finance Charge Plan')
	@GandalfProperty({ designType: Number })
	defaultFinanceChargePlanId!: number | null;

	@GandalfLabel('Email')
	@GandalfValidator({ sizeString: { message: 'Email cannot be longer than 255 characters', minLength: 0, maxLength: 255 } })
	@GandalfValidator({ email: { message: 'Invalid email format' } })
	@GandalfProperty({ designType: String })
	email!: string | null;

	@GandalfLabel('Facility Number')
	@GandalfValidator({ sizeString: { message: 'Facility Number cannot be longer than 50 characters', minLength: 0, maxLength: 50 } })
	@GandalfProperty({ designType: String })
	facilityNumber!: string | null;

	@GandalfConstantDecorator(constants.FacilityType)
	@GandalfLabel('Facility Type')
	@GandalfProperty({ designType: constants.FacilityType })
	facilityType!: constants.FacilityType | null;

	@GandalfLabel('FEIN')
	@GandalfValidator({ sizeString: { message: 'FEIN cannot be longer than 100 characters', minLength: 0, maxLength: 100 } })
	@GandalfProperty({ designType: String })
	fein!: string | null;

	@GandalfLabel('Logo')
	@GandalfProperty({ designType: Number })
	logoPracticeFileId!: number | null;

	@GandalfLabel('Location Name')
	@GandalfValidator({ notNull: { message: 'Location Name is required' } })
	@GandalfValidator({ sizeString: { message: 'Location Name must be between 1 and 100 characters', minLength: 1, maxLength: 100 } })
	@GandalfProperty({ designType: String, isRequired: true })
	name!: string;

	@GandalfLabel('NPI')
	@GandalfValidator({ sizeString: { message: 'NPI must be between 10 and 15 characters', minLength: 10, maxLength: 15 } })
	@GandalfProperty({ designType: String })
	npi!: string | null;

	@GandalfSubRequestLabel('Pay-To Address')
	@GandalfProperty({ designType: AddressOptionalRequest })
	payToAddress!: AddressOptionalRequest | null;

	@GandalfValidator({ notNull: { message: 'Phones are required' } })
	@GandalfProperty({ designType: AdminLocationPhoneRequest, isRequired: true })
	phones!: AdminLocationPhoneRequest;

	@GandalfLabel('Print Name As')
	@GandalfValidator({ sizeString: { message: 'Print Name As cannot be longer than 100 characters', minLength: 0, maxLength: 100 } })
	@GandalfProperty({ designType: String })
	printNameAs!: string | null;

	@GandalfConstantDecorator(constants.BillingId)
	@GandalfLabel('Provider Billing ID')
	@GandalfProperty({ designType: constants.BillingId })
	providerBillingId!: constants.BillingId | null;

	@GandalfConstantDecorator(constants.ServiceLocationIndicator)
	@GandalfLabel('Service Location Indicator')
	@GandalfProperty({ designType: constants.ServiceLocationIndicator })
	serviceLocationIndicator!: constants.ServiceLocationIndicator | null;

	@GandalfLabel('Location #')
	@GandalfValidator({ sizeString: { message: 'Location # cannot be longer than 50 characters', minLength: 0, maxLength: 50 } })
	@GandalfProperty({ designType: String })
	storeNumber!: string | null;

	@GandalfLabel('Use Current Location For Claims')
	@GandalfValidator({ notNull: { message: 'Use Current Location For Claims is required' } })
	@GandalfProperty({ designType: Boolean, isRequired: true })
	useCurrentLocationForClaims!: boolean;

	@GandalfLabel('Use Current Location For Statements')
	@GandalfValidator({ notNull: { message: 'Use Current Location For Statements is required' } })
	@GandalfProperty({ designType: Boolean, isRequired: true })
	useCurrentLocationForStatements!: boolean;

	@GandalfLabel('Web Site')
	@GandalfValidator({ sizeString: { message: 'Web Site cannot be longer than 255 characters', minLength: 0, maxLength: 255 } })
	@GandalfProperty({ designType: String })
	websiteUrl!: string | null;

}
